import React from "react";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../contexts/ThemeContext";

export default function Footer() {
  const navigate = useNavigate();
  const { darkMode } = useTheme();

  return (
    <footer
      className={`
        w-full mt-8 border-t
        ${darkMode ? "dark" : ""}
        bg-white dark:bg-gray-900
        border-gray-200 dark:border-gray-700
        text-gray-700 dark:text-gray-300
      `}
    >
      <div className="max-w-6xl mx-auto px-4 py-4 text-center space-y-2 text-xs sm:text-sm">

        {/* ROW 1 — BRAND */}
        <div>
          <span className="font-semibold text-pink-600 dark:text-pink-300">
            Bubble Butter
          </span>
          <span className="mx-2">•</span>
          <span>
            Handmade, natural & chemical-free products
          </span>
        </div>

        {/* ROW 2 — LINKS */}
        <div className="flex flex-wrap justify-center gap-x-4 gap-y-1">
          <button onClick={() => navigate("/products")} className="hover:text-pink-600 dark:hover:text-pink-300">
            Products
          </button>
          <button onClick={() => navigate("/contact")} className="hover:text-pink-600 dark:hover:text-pink-300">
            Contact
          </button>
          <button onClick={() => navigate("/privacy-policy")} className="hover:text-pink-600 dark:hover:text-pink-300">
            Privacy Policy
          </button>
          <button onClick={() => navigate("/terms-and-conditions")} className="hover:text-pink-600 dark:hover:text-pink-300">
            Terms & Conditions
          </button>
        </div>

        {/* ROW 3 — SUPPORT */}
        <div>
          📧 bubblebutter.help@gmail.com
          <span className="mx-2">•</span>
          © {new Date().getFullYear()} Bubble Butter
        </div>

      </div>
    </footer>
  );
}
